import React, { useEffect, useState } from 'react';
import { EyeIcon } from 'lucide-react';
export function LiveVisitorCounter() {
  const [visitors, setVisitors] = useState(() => Math.floor(Math.random() * 20) + 35);
  useEffect(() => {
    const interval = setInterval(() => {
      setVisitors(prev => {
        const change = Math.floor(Math.random() * 5) - 2;
        const next = prev + change;
        return Math.max(18, Math.min(65, next));
      });
    }, 4000);
    return () => clearInterval(interval);
  }, []);
  return <div className="flex items-center justify-center gap-2 py-3" data-id="element-61">
      <div className="flex items-center gap-2 bg-spiritual-800/60 backdrop-blur-sm text-spiritual-200 text-sm font-body px-4 py-2 rounded-full border border-spiritual-700/50" data-id="element-62">
        <EyeIcon className="w-4 h-4 text-spiritual-400" aria-hidden="true" data-id="element-63" />
        <span className="relative flex h-2 w-2" data-id="element-64">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" data-id="element-65" />
          <span className="relative inline-flex rounded-full h-2 w-2 bg-green-400" data-id="element-66" />
        </span>
        <span data-id="element-67">
          <strong className="text-spiritual-300" data-id="element-68">{visitors}</strong> personas
          viendo esta página ahora
        </span>
      </div>
    </div>;
}